module.exports = __webpack_public_path__ + "media/Teil 4.bc00598c.webm";